var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmBalckBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2582_53499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.075 12.8926C7.37031 12.9965 7.6875 12.7805 7.6875 12.4688V2.14922C7.6875 2.03437 7.64375 1.91953 7.55078 1.84844C7.01484 1.42187 5.78438 0.875 4.1875 0.875C2.80664 0.875 1.51602 1.23867 0.744922 1.53398C0.435938 1.6543 0.25 1.96055 0.25 2.29141V12.4168C0.25 12.7422 0.6 12.9691 0.908984 12.868C1.77031 12.5809 3.13477 12.25 4.1875 12.25C5.11445 12.25 6.34766 12.6328 7.075 12.8926ZM9.175 12.8926C9.90234 12.6328 11.1355 12.25 12.0625 12.25C13.1152 12.25 14.4797 12.5809 15.341 12.868C15.65 12.9719 16 12.7422 16 12.4168V2.29141C16 1.96055 15.8141 1.6543 15.5051 1.53672C14.734 1.23867 13.4434 0.875 12.0625 0.875C10.4656 0.875 9.23516 1.42187 8.69922 1.84844C8.60898 1.91953 8.5625 2.03437 8.5625 2.14922V12.4688C8.5625 12.7805 8.88242 12.9965 9.175 12.8926Z",
    fill: "#4B5563"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2582_53499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 14,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmBalckBook);
export default __webpack_public_path__ + "static/media/sm-balck-book.dd90af143099f373bb7fd6652232498b.svg";
export { ForwardRef as ReactComponent };